export default "__VITE_ASSET__CPb4QQ15__"